import * as React from "react";

const SvgComponent = ({ width = "14px", height = "15px", ...props }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 15"
    {...props}
  >
    <path
      d="M13.21 1.104c-.3-.048-1.242.07-3.338-.301A25.015 25.015 0 0 1 6.692 0s-.987.473-2.936.803c-2.425.41-3.582.3-3.582.3s-.66 7.6.594 10.108C1.73 13.136 5.814 14.681 6.69 15c.878-.32 4.962-1.863 5.924-3.789 1.255-2.508.595-10.107.595-10.107Zm-1.843 9.37c-.76 1.52-3.983 2.737-4.675 2.99-.693-.253-3.916-1.47-4.675-2.99-.99-1.98-.47-7.978-.47-7.978l5.144-.898 5.145.898s.521 5.999-.469 7.978Z"
      fill={props.color ? props.color : "#49B3E0"}
    />
    <path
      d="M6.926 2.182s-.528 10.379 0 10.64c.62-.226 3.505-1.317 4.185-2.677.886-1.771.42-7.14.42-7.14l-4.605-.823Z"
      fill={props.color ? props.color : "#49B3E0"}
    />
  </svg>
);

export default SvgComponent;
